/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ConfirmDeleteCancelDialog.vue?vue&type=template&id=d17ae71c"
import script from "./ConfirmDeleteCancelDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteCancelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d17ae71c')) {
      api.createRecord('d17ae71c', component.options)
    } else {
      api.reload('d17ae71c', component.options)
    }
    module.hot.accept("./ConfirmDeleteCancelDialog.vue?vue&type=template&id=d17ae71c", function () {
      api.rerender('d17ae71c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/doctors/ConfirmDeleteCancelDialog.vue"
export default component.exports